
import {
    AssetTypes, BoolLike, BuildType, DebtTypes,
    EmploymentBases,
    EmploymentTypes,
    Frequencies,
    PersonalMaritalStatuses
} from "../../../../models";

import countries from "../../countries.json";

export default function (mortgage, config) {
    // ID documents
    const id_domuments = () => {
        let map = {}
        let ask = []
        //map["Proof of identity"] = {check: true}
        map["proof-of-identity"] = true
        //map["Proof of address"] = {check: true}
        map["proof-of-address"] = true
        //map["Broker declaration"] = {check: true}
        if ([PersonalMaritalStatuses.MARRIED, PersonalMaritalStatuses.REMARRIED].includes(mortgage.applicant1.personal.maritalStatus) || mortgage.twoApplicants && [PersonalMaritalStatuses.MARRIED, PersonalMaritalStatuses.REMARRIED].includes(mortgage.applicant2.personal.maritalStatus)) {
            //map["Marriage cert"] = {check: true}
            map["marriage-cert"] = true
        }
        let answer1 = mortgage.applicant1.personal.nationality
        let country1 = !!answer1 ? countries.find(item => item.alpha_2_code === answer1) : false
        let answer2 = mortgage.twoApplicants && mortgage.applicant1.personal.nationality
        let country2 = !!answer2 && countries.find(item => item.alpha_2_code === answer2)
        if ((!!country1 && !country1.is_EU) || (!!country2 && !country2.is_EU)) {
            map["irish-residence-permit"] = true
            //map['Irish residence permit'] = {check: true}
            map["national-id-card"] = true
            //map['National ID card'] = {check: true}

            if ((answer1 && !country1.is_EU && mortgage.applicant1.personal.hasResidencePermit) || (answer2 && !country2.is_EU && mortgage.twoApplicants && mortgage.applicant2.personal.hasResidencePermit)) {
                map["critical-skills-employment-permit"] = true
                // map['Critical skills employment permit'] = {check: true}
            }
        }
        return {map, ask}
    }
    const paye = () => {
        let map = {}
        let ask = []
        const paye_jobs_1 = mortgage.applicant1.employmentIncome.filter(e => e.employmentType === EmploymentTypes.EMPLOYED)
        const paye_jobs_2 = mortgage.twoApplicants ? mortgage.applicant2.employmentIncome.filter(e => e.employmentType === EmploymentTypes.EMPLOYED) : []

        if (paye_jobs_1.length || paye_jobs_2.length) {
            map['salary-certificate'] = true
            // map['Salary certificate'] = {check: {option:'Yes'}}
            // 3 months paylsips
            let payslips3 = paye_jobs_1.find(e => !e.payFrequency || e.payFrequency === Frequencies.MONTHLY) || paye_jobs_2.find(e => !e.payFrequency || e.payFrequency === Frequencies.MONTHLY)
            if (payslips3) {
                map['3-payslips'] = true
                //map['3 payslips'] = {check: true}
            }
            let payslips4 = paye_jobs_1.find(e => [Frequencies.FORTNIGHTLY, Frequencies.WEEKLY].includes(e.payFrequency)) || paye_jobs_2.find(e => [Frequencies.FORTNIGHTLY, Frequencies.WEEKLY].includes(e.payFrequency))
            if (payslips4) {
                map['4-payslips'] = true
                //map['4 payslips'] = {check: true}
            }
            map['latest-employment-detail-summary'] = true
            //map['Latest Employment Detail Summary'] = {check: true}
            let contract = paye_jobs_1.find(e => e.employmentBasis === EmploymentBases.CONTRACT) || paye_jobs_2.find(e => e.employmentBasis === EmploymentBases.CONTRACT)
            if (contract) {
                map['employment-contract'] = true
                //map['Employment contract'] = {check: true}
            }
            ask.push({
                name: 'employer-letter',
                label: 'Employer Letter',
                type: 'CHECK',
                group: 'EMPLOYMENT'
            })
            if (config['employer-letter']) {
                map['employer-letter'] = true
                //map['Employer letter'] = {check: true}
            }
            ask.push({
                name: 'social-protection-statement',
                label: 'Social Protection Statement',
                type: 'CHECK',
                group: 'EMPLOYMENT'
            })
            if (config['social-protection-statement']) {
                map['social-protection'] = true
                //map['Social protection'] = {check: true}
            }
        }
        return {map, ask}
    }
    const selfEmployed = () => {
        let map = {}
        let ask = []
        let self = mortgage.applicant1.employmentIncome.find(e => e.employmentType === EmploymentTypes.SELFEMPLOYED) || mortgage.twoApplicants && mortgage.applicant2.employmentIncome.find(e => e.employmentType === EmploymentTypes.SELFEMPLOYED)
        if (self) {
            map['certified-audited-accounts'] = true
            //map['Certified audited accounts'] = {check: true}
            map['form-11'] = true
            //map['Form 11'] = {check: true}
            map['ros-charges'] = true
            //map['ROS charges'] = {check: true}
            ask.push({
                name: 'management-accounts',
                label: 'Management Accounts',
                type: 'CHECK',
                group: 'EMPLOYMENT'
            })
            if (config['management-accounts']) {
                map['management-accounts'] = true
                //map['Management accounts'] = {check: true}
            }
            ask.push({
                name: 'evidence-of-contracts',
                label: 'Evidence of contracts',
                type: 'CHECK',
                group: 'EMPLOYMENT'
            })
            if (config['evidence-of-contracts']) {
                map['evidence-of-contracts'] = true
                //   map['Evidence of contracts'] = {check: true}
            }
            ask.push({
                name: 'form11-rental-income',
                label: 'Form 11 For Rental Income',
                type: 'CHECK',
                group: 'EMPLOYMENT'
            })
            if (config['form11-rental-income']) {
                map["form-11-confirming-rental-income"] = true
                // map['Form 11 confirming rental income'] = {check: true}
            }
            ask.push({
                name: 'P21 Statement',
                label: 'P21 Statement',
                type: 'CHECK',
                group: 'EMPLOYMENT'
            })
            if (config['P21 Statement']) {
                map["p21"] = true
                //map['P21'] = {check: true}
            }
        }
        return {map, ask}
    }

    const recentBankStatements = () => {
        let map = {}
        map['personal-current-account-statements'] = true
        //map['Personal current account statements'] = {check: true}
        let self = mortgage.applicant1.employmentIncome.find(e => e.employmentType === EmploymentTypes.SELFEMPLOYED) || mortgage.twoApplicants && mortgage.applicant2.employmentIncome.find(e => e.employmentType === EmploymentTypes.SELFEMPLOYED)
        if (self){
            map['business-current-account-statements'] = true
            //map['Business current account statements'] = {check: true}
        }
        const otheraccounts1 = mortgage.applicant1.accounts.length > 1 || mortgage.applicant1.assets.filter(a=>a.assetType === AssetTypes.SAVING).length > 0
        const otheraccounts2 = mortgage.twoApplicants && (mortgage.applicant2.accounts.length > 1 || mortgage.applicant2.assets.filter(a=>a.assetType === AssetTypes.SAVING).length > 0)
        if (otheraccounts1 || otheraccounts2) {
            map['other-current-account-statements'] = true
            // map['Other current account statements'] = {check: true}
        }
        const debts1 = mortgage.applicant1.debts.filter(d=>d.debtType === DebtTypes.LOAN)
        const debts2 = mortgage.twoApplicants ? mortgage.applicant2.debts.filter(d=>d.debtType === DebtTypes.LOAN) : []
        if (debts1.length || debts2.length) {
            map['loan-facility-ststement-for-the-past-12-months'] = true
            // map['Loan facility ststement for the past 12 months'] = {check: true}
        }
        return {map}
    }

    const balanceOfFunds = () => {
        let map = {}
        if (mortgage.requirement.receivingGifts){
            map['gift-letter'] = true
            //map['Gift letter'] = {check: true}
        }
        map['personal-savings-account-statements-within-the-last-6-weeks-'] = true
        //map['Personal savings account statements (within the last 6 weeks)'] = {check: true}


        if (mortgage.property.bookingDepositPaid || mortgage.property.contractDepositPaid){
            map["booking-deposit-receipt"] = true
            //map['Booking deposit receipt'] = {check: true}
        }
        const investments1 = mortgage.applicant1.assets.filter(a=>a.assetType === AssetTypes.INVESTMENT)
        const investments2 = mortgage.twoApplicants ? mortgage.applicant2.assets.filter(a=>a.assetType === AssetTypes.INVESTMENT) : []
        if (investments1.length || investments2.length) {
            map["investment-account-statements"] = true
            //map['Investment account statements'] = {check: true}
        }
        if (mortgage.requirement.helpToBuyScheme !== BoolLike.FALSE){
            map["help-to-buy-confirmation"] = true
            //            map['Help to Buy confirmation'] = {check: true}
        }
        return {map}

    }

    const application = () => {
        let map = {}
        map['cover-letter-2'] = true
        //map['Cover letter 2'] = {check: true}
        map["application-form-full-or-abridged-"] = true
        //map['Application form (full or abridged)'] = {check: true}
        map["broker-checklist"]=true
        //map['Broker checklist'] = {check: true}
        map["broker-calculator"] = true
        //map['Broker calculator'] = {check: true}
        map["electronic-signature-certification"] = true
        //map['Electronic signature certification'] = {check: true}
        let agreements1 = [PersonalMaritalStatuses.DIVORCED, PersonalMaritalStatuses.SEPARATED].includes(mortgage.applicant1.personal.maritalStatus) || mortgage.applicant1.financial.paysMaintenance
        let agreements2 = mortgage.twoApplicants && ([PersonalMaritalStatuses.DIVORCED, PersonalMaritalStatuses.SEPARATED].includes(mortgage.applicant2.personal.maritalStatus) || mortgage.applicant2.financial.paysMaintenance)
        if (agreements1 || agreements2){
            map["divorce-seperation-maintenance-agreement"] = true
            //map['Divorce/seperation/maintenance agreement'] = {check: true}
        }
        if (mortgage.property.buildType === BuildType.SELFBUILD){
            map["estimates-of-works"] = true
            //map['Estimates of works'] = {check: true}
        }
        let answer1 = mortgage.applicant1.personal.nationality
        let country1 = !!answer1 ? countries.find(item => item.alpha_2_code === answer1) : false
        let answer2 = mortgage.twoApplicants && mortgage.applicant1.personal.nationality
        let country2 = !!answer2 && countries.find(item => item.alpha_2_code === answer2)
        let yearSomewhere3 = mortgage.applicant1.personal.otherCountryOfResidenceInPast3Years || mortgage.twoApplicants && mortgage.applicant2.personal.otherCountryOfResidenceInPast3Years
        if ((!!country1 && !country1.is_EU) || (!!country2 && !country2.is_EU) || yearSomewhere3) {
            map["international-credit-report"] = true
            //map['International credit report'] = {check: true}
        }
        map["other-supporting-documentation"] = true
        // map['Other supporting documentation'] = {check: true}
        return {map}
    }

    const sections = [
        id_domuments(),
        paye(),
        selfEmployed(),
        recentBankStatements(),
        balanceOfFunds(),
        application(),
    ]
    return {sections}
}

// import {AssetTypes, BuildType, DebtTypes, EmploymentBases, EmploymentTypes, Frequencies, PersonalMaritalStatuses} from "../../../../models";
// import countries from "../../countries.json";
// import {legacyIncome} from "../../../../app/components/client/application-stages/_common/lender-tests/useXlsTests";
// import {balanceOfFundsCosts, balanceOfFundsFunds} from "../../../../app/components/client/application-stages/_common/funding/BalanceOfFunds";
//
// export default function (mortgage, config) {
//     // --------------------------------------------------------------------------------------------
//     // OVERLAY SECTIONS
//
//     // Balance of Funds
//     const {
//               price,
//               stampDuty,
//               legalFees,
//               propertyValuation,
//               totalCosts
//           } = balanceOfFundsCosts(mortgage)
//     const costs = [
//         {
//             key   : 1,
//             name  : "Price",
//             amount: price
//         },
//         {
//             key   : 2,
//             name  : "Stamp Duty",
//             amount: stampDuty
//         },
//         {
//             key   : 3,
//             name  : "Legal Fees",
//             amount: legalFees
//         },
//         {
//             key   : 4,
//             name  : "Property Valuation",
//             amount: propertyValuation
//         }
//     ]
//     const {
//               loan,
//               gifts,
//               helpToBuy: htbScheme,
//               firstHome,
//               requiredSavings,
//               bookingDepositPaid,
//               contractDepositPaid
//           } = balanceOfFundsFunds(mortgage)
//
//     const funds = []
//     if (loan > 0) {
//         funds.push({
//             key   : 0,
//             name  : "Mortgage",
//             amount: loan
//         })
//     }
//     if (gifts > 0) {
//         funds.push({
//             key   : 1,
//             name  : "Gifts",
//             amount: gifts
//         })
//     }
//     if (htbScheme > 0) {
//         funds.push({
//             key   : 2,
//             name  : "Help to Buy",
//             amount: htbScheme
//         })
//     }
//     if (firstHome > 0) {
//         funds.push({
//             key   : 3,
//             name  : "First Home",
//             amount: firstHome
//         })
//     }
//     if (bookingDepositPaid > 0){
//         funds.push({
//             key   : 4,
//             name  : "Booking Deposit Paid",
//             amount: bookingDepositPaid
//         })
//     }
//     if (contractDepositPaid > 0){
//         funds.push({
//             key   : 5,
//             name  : "Contract Deposit Paid",
//             amount: contractDepositPaid
//         })
//     }
//     funds.push({
//         key   : 6,
//         name  : "Savings",
//         amount: requiredSavings
//     })
//
//     //Nicely space the cells so totals are at the bottom
//     if (funds.length > costs.length) {
//         let diff = funds.length - costs.length
//         for (let i = 0; i < diff; i++) {
//             costs.push({
//                 key   : `c.${i}`,
//                 name  : "",
//                 amount: ""
//             })
//         }
//     }
//     else if (costs.length > funds.length) {
//         let diff = costs.length - funds.length
//         for (let i = 0; i < diff; i++) {
//             funds.push({
//                 key   : `f.${i}`,
//                 name  : "",
//                 amount: ""
//             })
//         }
//     }
//     costs.push({
//         key   : 'tF',
//         name  : "TOTAL",
//         amount: totalCosts
//     })
//     funds.push({
//         key   : 'tC',
//         name  : "TOTAL",
//         amount: totalCosts
//     })
//     let  map = {}
//     costs.forEach((cost, index) => {
//         map[`costs${index + 1}`] = cost.name
//         map[`costs${index + 1}-a`] = cost.amount.toString()
//     })
//     funds.forEach((fund, index) => {
//         map[`funds${index + 1}`] = fund.name
//         map[`funds${index + 1}-a`] = fund.amount.toString()
//     })
//
//     // --------------------------------------------------------------------------------------------
//     // FILL SECTIONS
//
//     let legacyEmployment = legacyIncome(mortgage)
//     let paye
//     let selfEmployed
//     let payeMonthly
//     let payeWeekly
//     let contract
//     if (legacyEmployment) {
//         paye = mortgage.applicant1.employment.employmentType === EmploymentTypes.EMPLOYED || mortgage.twoApplicants && mortgage.applicant2.employment.employmentType === EmploymentTypes.EMPLOYED
//         selfEmployed
//             = mortgage.applicant1.employment.employmentType === EmploymentTypes.SELFEMPLOYED || mortgage.twoApplicants && mortgage.applicant2.employment.employmentType === EmploymentTypes.SELFEMPLOYED
//         payeMonthly = paye && ( mortgage.applicant1.income.payFrequency === Frequencies.MONTHLY || mortgage.twoApplicants && mortgage.applicant2.income.payFrequency === Frequencies.MONTHLY )
//         payeWeekly = paye && ([Frequencies.WEEKLY, Frequencies.FORTNIGHTLY].includes( mortgage.applicant1.income.payFrequency)  || [Frequencies.WEEKLY, Frequencies.FORTNIGHTLY].includes( mortgage.applicant2.income.payFrequency))
//         contract = false
//     }
//     else {
//         paye
//             = mortgage.applicant1.employmentIncome.find(e => e.employmentType === EmploymentTypes.EMPLOYED) || mortgage.twoApplicants && mortgage.applicant2.employmentIncome.find(e => e.employmentType === EmploymentTypes.EMPLOYED)
//         selfEmployed
//             = mortgage.applicant1.employmentIncome.find(e => e.employmentType === EmploymentTypes.SELFEMPLOYED) || mortgage.twoApplicants && mortgage.applicant2.employmentIncome.find(e => e.employmentType === EmploymentTypes.SELFEMPLOYED)
//         payeMonthly = paye && ( mortgage.applicant1.employmentIncome.find(e => e.employmentType === EmploymentTypes.EMPLOYED && e.payFrequency === Frequencies.MONTHLY) || mortgage.twoApplicants && mortgage.applicant2.employmentIncome.find(e => e.employmentType === EmploymentTypes.EMPLOYED && e.payFrequency === Frequencies.MONTHLY) )
//         payeWeekly = paye && ( mortgage.applicant1.employmentIncome.find(e => e.employmentType === EmploymentTypes.EMPLOYED && [Frequencies.WEEKLY, Frequencies.FORTNIGHTLY].includes(e.payFrequency)) || mortgage.twoApplicants && mortgage.applicant2.employmentIncome.find(e => e.employmentType === EmploymentTypes.EMPLOYED && [Frequencies.WEEKLY, Frequencies.FORTNIGHTLY].includes(e.payFrequency)) )
//         contract = mortgage.applicant1.employmentIncome.find(e => e.employmentType === EmploymentTypes.EMPLOYED && e.employmentBasis === EmploymentBases.CONTRACT) || mortgage.twoApplicants && mortgage.applicant2.employmentIncome.find(e => e.employmentType === EmploymentTypes.EMPLOYED && e.employmentBasis === EmploymentBases.CONTRACT)
//     }
//     let selfBuild = mortgage.properties[0]?.buildType === BuildType.SELFBUILD
//
//
//     let fill = {}
//     let ask = []
//
//     // proof of identity
//     fill['undefined'] = {check: true}
//
//     // Proof of address
//     fill['Proof of address dated within last 6 months'] = {check: true}
//
//     // Broker declaration identity form
//     fill['undefined_4'] = {check: true}
//
//     // Marriage Certificate
//     let anybodyMarried = [
//         PersonalMaritalStatuses.MARRIED,
//         PersonalMaritalStatuses.REMARRIED
//     ].includes(mortgage.applicant1.personal.maritalStatus)
//     if (!anybodyMarried && mortgage.twoApplicants) {
//         anybodyMarried = [
//             PersonalMaritalStatuses.MARRIED,
//             PersonalMaritalStatuses.REMARRIED
//         ].includes(mortgage.applicant2.personal.maritalStatus)
//     }
//     fill['undefined_2'] = {check: !!anybodyMarried}
//
//     // Residency Permit
//     let permitRequired = false
//     let answer = mortgage.applicant1.personal.nationality
//     let country = !!answer ? countries.find(item => item.alpha_2_code === answer) : false
//     if (!!country && !country.is_EU) {
//         permitRequired = true
//     }
//     if (!permitRequired && mortgage.twoApplicants) {
//         answer = mortgage.applicant2.personal.nationality
//         country = !!answer ? countries.find(item => item.alpha_2_code === answer) : false
//         if (!!country && !country.is_EU) {
//             permitRequired = true
//         }
//     }
//     fill['undefined_3'] = {check: !!permitRequired}
//
//     //National ID Card
//     ask.push({
//         name: 'nationalIdCard',
//         label: 'National ID Card',
//         type: 'CHECK',
//         group: 'CHECKS'
//     })
//     if (config.hasOwnProperty('nationalIdCard')) {
//         fill['undefined_5'] = {check: !!config.nationalIdCard}
//     }
//     else{
//         fill['undefined_5'] = {check: false}
//     }
//
//
//     //Critical skills employment permit
//     ask.push({
//         name: 'criticalSkillsPermit',
//         label: 'Critical Skills Permit',
//         type: 'CHECK',
//         group: 'CHECKS'
//     })
//     if (config.hasOwnProperty('criticalSkillsPermit')) {
//         fill['undefined_6'] = {check: !!config.criticalSkillsPermit}
//     }
//     else {
//         fill['undefined_6'] = {check: false}
//     }
//
//     // *** PAYE ***
//
//     //Salary Cert
//     fill['toggle_9'] = {check: !!paye}
//
//     //Payslips - Monthly
//     fill['3 payslips monthly and not older than 6 weeks'] = {check: !!payeMonthly}
//
//     //Payslips - Weekly/Fortnightly
//     fill['4 payslips weeklyfortnightly and not older'] = {check: !!payeWeekly}
//
//     //EDS
//     fill['Latest Employment Detail Summary EDS or if'] = {check: !!paye}
//
//     //Contract
//     fill['undefined_7'] = {check: !!contract}
//
//     // Employer letter
//     ask.push({
//         name: 'employerLetter',
//         label: 'Employer Letter',
//         type: 'CHECK',
//         group: 'CHECKS'
//     })
//     if (config.hasOwnProperty('employerLetter')) {
//         fill['undefined_8'] = {check: !!config.employerLetter}
//     }
//     else{
//         fill['undefined_8'] = {check: false}
//     }
//
//     // Social protection income statement
//     fill['undefined_9'] = {check: false}
//
//     // *** Self Employed ***
//
//     // Certified/audited accounts x2 most
//     fill['toggle_16'] = {check: !!selfEmployed}
//
//     // Form 11 or chapter 4 x2 most recent years
//     fill['Form 11 or chapter 4 x2 most recent years'] = {check: !!selfEmployed}
//
//     // ROS charges payments statement or
//     fill['ROS charges  payments statement or'] = {check: !!selfEmployed}
//
//     // Management accounts
//     fill['undefined_10'] = {check: !!selfEmployed}
//
//     // Evidence of contracts
//     fill['undefined_11'] = {check: !!selfEmployed}
//
//     // Form 11 confirming rental income
//     let rentalIncome = false
//     if (mortgage.applicant1.properties.find(p => p.isRented) || (mortgage.twoApplicants && mortgage.applicant2.properties.find(p => p.isRented))) {
//         rentalIncome = true
//     }
//     fill['undefined_12'] = {check: !!rentalIncome}
//
//     // P21 (statement of liability)
//     fill['undefined_13'] = {check: false}
//
//
//     // *** Personal Bank Statements ***
//     fill['Personal current account statements must'] = {check: true}
//
//     // Business current account statements (must cover 6 months
//     fill['Business current account statements must cover 6 months'] = {check: !!selfEmployed}
//
//     // Other current account statements
//     let otherAccounts = mortgage.applicant1.accounts.length > 1 || mortgage.twoApplicants && mortgage.applicant2.accounts.length > 1
//     fill['Other current account statements eg Revolut'] = {check: !!otherAccounts}
//
//     // Loan Statements
//     let hasLoans = mortgage.applicant1.debts.find(d => d.debtType === DebtTypes.LOAN) || mortgage.twoApplicants && mortgage.applicant2.debts.find(d => d.debtType === DebtTypes.LOAN)
//     fill['Loan facility statement for the past 12 months if not evident'] = {check: !!hasLoans}
//
//     // Gift Letter
//     let receivingGift = mortgage.requirement.receivingGifts && mortgage.requirement.depositGifts > 0
//     fill['undefined_14'] = {check: !!receivingGift}
//
//     // Investment account statements
//     let hasInvestments = mortgage.applicant1.assets.find(a => a.assetType === AssetTypes.INVESTMENT) || mortgage.twoApplicants && mortgage.applicant2.assets.find(a => a.assetType === AssetTypes.INVESTMENT)
//     fill['Investment account'] = {check: !!hasInvestments}
//
//     // Personal savings account
//     let hasSavings = mortgage.applicant1.assets.find(a => a.assetType === AssetTypes.SAVING) || mortgage.twoApplicants && mortgage.applicant2.assets.find(a => a.assetType === AssetTypes.SAVING)
//     fill['Personal savings account statements within the last 6'] = {check: !!hasSavings}
//
//     // Booking deposit receipt
//     let hasPaidBooking = mortgage.requirement.depositPaid > 0
//     fill['undefined_15'] = {check: !!hasPaidBooking}
//
//     // Help to Buy confirmation
//     let helpToBuy = mortgage.requirement.helpToBuyScheme && mortgage.requirement.helpToBuySchemeAmount > 0
//     fill['undefined_16'] = {check: !!helpToBuy}
//
//     // Cover letter
//     fill['undefined_17'] = {check: true}
//
//     // Application form
//     fill['undefined_20'] = {check: true}
//
//     // Broker checklist
//     fill['undefined_23'] = {check: true}
//
//     // Broker calculator
//     fill['undefined_18'] = {check: true}
//
//     // Other supporting  documentation
//     ask.push({
//         name: 'otherSupportingDocs',
//         label: 'Other Supporting Documentation',
//         type: 'CHECK',
//         group: 'CHECKS'
//     })
//     if (config.hasOwnProperty('otherSupportingDocs')) {
//         fill['undefined_24'] = {check: !!config.otherSupportingDocs}
//     }
//     else{
//         fill['undefined_24'] = {check: false}
//     }
//
//     // *** Self Build ? ***
//
//     // Estimates of works
//     fill['undefined_19'] = {check: !!selfBuild}
//
//
//     // International credit report
//     fill['undefined_22'] = {check: !!permitRequired}
//
//     // Divorce/separation/maintenance agreement
//     let needsAgreement =  (
//         [PersonalMaritalStatuses.DIVORCED, PersonalMaritalStatuses.REMARRIED].includes( mortgage.applicant1.personal.maritalStatus) ||
//         (mortgage.twoApplicants && [PersonalMaritalStatuses.DIVORCED, PersonalMaritalStatuses.REMARRIED].includes(mortgage.applicant2.personal.maritalStatus)) ||
//         mortgage.applicant1.personal.maritalStatus === PersonalMaritalStatuses.SEPARATED ||
//         (mortgage.twoApplicants && mortgage.applicant2.personal.maritalStatus === PersonalMaritalStatuses.SEPARATED))
//     fill['undefined_25'] = {check: !!needsAgreement}
//
//
//     return {sections:[{fill, ask, map}]}
//
//
// }